/**
 * The short-id disambiguator (2026-07-21, Leon's ruling): display names are
 * never composed with an owning context ("Group · Flow" is retired - the owner
 * is an access anchor, not a filing parent), so same-named entities need a
 * neutral tiebreaker. This is it: the leading fragment of the entity's own id,
 * rendered in mono and quiet (typically hover-revealed). It identifies without
 * implying ownership, hierarchy, or containment.
 */
export function shortId(id: string): string {
  return id.replace(/-/g, '').slice(0, 6);
}
